import axios from "axios";

// For Development Server
const URL = process.env.REACT_APP_BASE_URL_DEV;

// For Production Server
// const URL = process.env.REACT_APP_BASE_URL_PRODUCTION; 

const middleURL = '/api'
const apiBaseURL = URL + middleURL;

const getBaseURL = () => {
    return apiBaseURL;
}

const getAxiosInstance = () => {
    return axios.create({ baseURL: apiBaseURL });
}

export { getBaseURL, getAxiosInstance }